import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export type Ratio =
    | '1:1'
    | '4:3'
    | '16:9'
    | '3:2'
    | '5:4'
    | '8:1'
    | '8:3'
    | '2:35'
    | '1:85'
    | '21:9'
    | '9:16';

export class ImageValidator {

    public static imageDimensions = (allowedRatio: Ratio[], tolerance: number): ValidatorFn =>
        (control: AbstractControl): ValidationErrors | null => {

            if (!control.value?.dimensions) {
                return null;
            }

            const { width, height } = control.value.dimensions;
            const imageRatio = ImageValidator.getAspectRatio(width, height);

            const isRatioClose = allowedRatio.some((ratio) => {
                const [requiredWidth, requiredHeight] = ratio.split(':').map(Number);
                const widthDiff = Math.abs(width - requiredWidth);
                const heightDiff = Math.abs(height - requiredHeight);
                return widthDiff <= tolerance && heightDiff <= tolerance;
            });

            const isExactRatio = allowedRatio.includes(imageRatio);

            return isRatioClose || isExactRatio
                ? null
                : { imageRatio: `The image ratio ${imageRatio.toString().replace(/\./, ':')} is not allowd. Supported image ratios: ${allowedRatio.join(',').replace(/\./, ':')}` };
        }

    private static getAspectRatio = (width: number, height: number): Ratio => {
        const calculate = (a: number, b: number): number => (b === 0 ? a : calculate(b, a % b));

        return `${width / calculate(width, height)}:${height / calculate(width, height)}` as Ratio;
    }

    public static imageDimensionInPx = (allowedDimensions: { width: number, height: number }[], tolerance = 0): ValidatorFn =>
        (control: AbstractControl): ValidationErrors | null => {
            if (!control.value?.dimensions) {
                return null;
            }

            const { width, height } = control.value.dimensions;

            const isDimensionClose = allowedDimensions.some((dimension) => {
                const widthDiff = Math.abs(width - dimension.width);
                const heightDiff = Math.abs(height - dimension.height);
                return widthDiff <= tolerance && heightDiff <= tolerance;
            });

            return isDimensionClose
                ? null
                : { imageDimensionInPx: `The image dimensions ${width}x${height} are not allowed. Supported image dimensions: ${allowedDimensions.map((dimension) => `${dimension.width}x${dimension.height}`).join(', ')}` };
        }
}
